import { CreateGiftCardBatchDocument } from "@/__generated__/graphql";
import { useMutation } from "@apollo/client";

export const useCreateGiftCardBatchMutation = () => {
  return useMutation(CreateGiftCardBatchDocument);
};
